import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import Copied from "./Copied";
import Add from "./Add";
import Remove from "./Remove";
import * as selectors from "../selectors";

const getTrianglePos = ({
  copiedVisible,
  addVisible,
  removeVisible,
  hasRemove
}) => {
  if (copiedVisible && hasRemove) {
    return "third";
  }
  if ((copiedVisible && !hasRemove) || (addVisible && hasRemove)) {
    return "second";
  }
  if (removeVisible || (addVisible && !hasRemove)) {
    return "first";
  }
};

export default ({ artId }) => {
  const copiedVisible = useSelector(selectors.copiedVisible)(artId);
  const addVisible = useSelector(selectors.addVisible)(artId);
  const removeVisible = useSelector(selectors.removeVisible)(artId);
  const hasRemove = useSelector(selectors.hasRemove)(artId);
  const trianglePos = getTrianglePos({
    copiedVisible,
    addVisible,
    removeVisible,
    hasRemove
  });
  return (
    <div className="fav__box">
      <div className={`fav__triangle fav__triangle--${trianglePos}`} />
      {copiedVisible && <Copied />}
      {addVisible && <Add artId={artId} />}
      {removeVisible && <Remove artId={artId} />}
    </div>
  );
};
